module.exports = __webpack_public_path__ + "static/media/prop-3-thumb.4a59a207.webp";